import { z } from 'zod';
import { LEGACY_TRACK_HEAD_ICON_IDS, TRACK_WIDTH_LIMITS } from './track-appearance.js';

/** Normalize legacy marker choices to the fixed dot and bound stroke settings. */
export const TrackAppearanceSchema = z.object({
  color: z.string().regex(/^#[0-9a-f]{6}$/i).transform(value => value.toLowerCase()),
  width: z.number().int().min(TRACK_WIDTH_LIMITS.min).max(TRACK_WIDTH_LIMITS.max),
  headIcon: z.enum(LEGACY_TRACK_HEAD_ICON_IDS).transform(() => 'dot' as const),
}).strict();

export function readStoredTrackAppearance(value: string | null | undefined) {
  return value == null ? undefined : TrackAppearanceSchema.parse(JSON.parse(value));
}
